<div class="col-sm-12 nopadding">
    <div class="card-header">
        <div class="col-sm-12 nopadding">
            <h2 class="border-btm">Cross BD <button type="button" (click)="CloseModal()" class="close pull-right"></button></h2>
        </div>
    </div>
    <form [formGroup]="crossBDForm" (submit)="SaveData()">
    <div class="card-body">
        <div class="col-sm-12 nopadding">
            <div class="row ">
                <div class="col-md-6"><b>Name:</b> {{lead_name}}</div>
                <!-- <div class="col-md-6"><b>Mobile:</b> {{mobile}}</div> -->
            </div>
            <div class="row mt-5">
                <div class="col-md-6"><b>City :</b> {{city_name}}</div>
                <div class="col-md-6"><b>Lead Created Time:</b> {{created_at}}</div>
            </div>
            <div class="row mt-5">
                <div class="col-md-6">
                  <mat-select  placeholder="Treatment" formControlName="tid" >
                    <input class="mySearchInput"
                    #treatmentModalSearch focused="'true'" type="text"
                    (keyup)="searchOnSelect($event.target.value, 'treatment_modal')"
                    (keydown)="$event.stopPropagation()" autocomplete="off"
                    placeholder="Search"
                    id="treatmentModalSearch">
                    <mat-option [value]="ltreatment.id" *ngFor="let ltreatment of alltreatments">{{ltreatment.name}}</mat-option>
                  </mat-select>
                    <div *ngIf="submitted && f.tid.errors" class="invalid-feedback">
                        <div *ngIf="f.tid.errors.required">Treatment is required</div>
                    </div>
                </div>
              <div class="col-md-6">
                <mat-select  placeholder="Team Lead" formControlName="tlid" (click)="setSearchValue('tl_modal')">
                  <input class="mySearchInput"
                  #tlModalSearch focused="'true'" type="text"
                  (keyup)="searchOnSelect($event.target.value, 'tl_modal')"
                  (keydown)="$event.stopPropagation()" autocomplete="off"
                  placeholder="Search"
                  id="tlModalSearch">
                  <mat-option [value]="tls.id" *ngFor="let tls of allTls">{{tls.name}} ({{tls.email}})</mat-option>
                </mat-select>
                <div *ngIf="submitted && f.tlid.errors" class="invalid-feedback">
                    <div *ngIf="f.tlid.errors.required">Team Lead is required</div>
                </div>
              </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <button style="margin-left: 15px;" type="submit" [disabled]="loading" class="btn btn-primary float-right" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> Submit</button>

        <button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button>
    </div>
    </form>
</div>
